import type React from 'react';

import type { ShortcutsConfig } from '@atlassian/global-side-navigation/types';
import { useOrderedAppShortcuts } from '@atlassian/global-shortcuts';

interface ReorderShortcutsContainerProps {
	children: (renderProps: {
		shortcuts: ReturnType<typeof useOrderedAppShortcuts>;
	}) => React.ReactNode;
	shortcutsConfig: ShortcutsConfig;
	customizationMenuConfig?: Parameters<typeof useOrderedAppShortcuts>[1];
}

export const ReorderShortcutsContainer = ({
	shortcutsConfig,
	customizationMenuConfig,
	children,
}: ReorderShortcutsContainerProps) => {
	// sort filtered products based on order of customizationMenuConfig
	const orderedShortcuts = useOrderedAppShortcuts(shortcutsConfig, customizationMenuConfig);

	return children({ shortcuts: orderedShortcuts });
};
